import { FormControl, FormLabel, RadioGroup } from '@mui/material';
import _, { PropsWithChildren } from 'react';

export interface WsRadioGroupProps {
  id?: string;
  label?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const WsRadioGroup = (props: PropsWithChildren<WsRadioGroupProps>) => {
  return (
    <FormControl>
      {props.label && <FormLabel>{props.label}</FormLabel>}
      <RadioGroup id={props.id} value={props.value} onChange={props.onChange}>
        {props.children}
      </RadioGroup>
    </FormControl>
  );
};
